<template>
  <div class="writeoff">
    <div v-if="!checkStatus&&isEmployee">
      <div class="wrap goods-info">
        <div class="title">商品信息</div>
        <div class="goods-div">
          <div>
            <img
              :src="goodsData.goodsImage"
              style="width: 2.35rem; height: 2.35rem"
            />
          </div>
          <div class="info-text">
            <div style="height: 1.7rem; overflow: hidden; color: #333">
              {{ goodsData.goodsName }}
            </div>
            <div>
              <span class="price">￥{{ goodsData.price }}</span>
              <span> x {{ goodsData.amount }}</span>
            </div>
          </div>
        </div>
        <div class="total">
          <span>总计：</span
          ><span style="color: #f0142d; font-size: 0.35rem; font-weight: bold"
            >￥{{ orderData.totalFee }}</span
          >
        </div>
      </div>
      <div class="wrap info" style="margin-top: 0.32rem">
        <div class="title">联系人信息</div>
        <div class="clo">
          <div><span>姓名：</span></div>
          <div>
            <span>{{ orderData.receiveUser }}</span>
          </div>
        </div>
        <div class="clo">
          <div><span>手机号：</span></div>
          <div>
            <span>{{ orderData.receivePhone }}</span>
          </div>
        </div>
      </div>
      <div class="wrap info" style="margin-top: 0.32rem; position: relative">
        <div class="title">订单信息</div>
        <div class="clo">
          <div><span>订单编号：</span></div>
          <div>
            <span>{{ orderData.orderCode }}</span>
          </div>
        </div>
        <div class="clo">
          <div><span>下单时间：</span></div>
          <div>
            <span>{{ orderData.createTime }}</span>
          </div>
        </div>
        <div class="clo">
          <div><span>订单来源：</span></div>
          <div>
            <span
              >【{{ orderData.sourceTypeText }}】{{
                orderData.sourceName
              }}</span
            >
          </div>
        </div>
        <div class="clo">
          <div><span>归属员工：</span></div>
          <div>
            <span>{{ orderData.rootEmplName }}</span>
          </div>
        </div>
        <div class="clo">
          <div><span>商品类型：</span></div>
          <div>
            <span>{{
              goodsData.deliveryType == 1 ? "邮寄商品" : "到店消费商品"
            }}</span>
          </div>
        </div>
        <div class="clo">
          <div><span>商品备注：</span></div>
          <div>
            <span>{{ orderData.desc }}</span>
          </div>
        </div>
        <div class="status" v-if="orderData.status == 1">未消费</div>
      </div>
      <div style="margin-top: 0.7rem">
        <div @click="checkOrder" class="btn">确认消费</div>
      </div>
    </div>
    <div v-if="checkStatus" style="text-align: center; margin-top: 2.5rem">
      <div>
        <img src="../../assets/images/hook.png" style="width: 1.2rem" />
      </div>
      <div class="used">已确认消费</div>
    </div>
    <div v-if="!isEmployee" style="text-align: center; margin-top: 2.5rem">
      <div class="used">您不是员工，不能进行核销哦</div>
    </div>
  </div>
</template>
<script>
import api from "api";
import utils from "@utils/index";
import wx from "weixin-js-sdk";
// import { Swipe, SwipeItem } from "mint-ui";
export default {
  name: "goodsDetails",
  // components: { "mt-swipe": Swipe, "mt-swipe-item": SwipeItem },
  data() {
    return {
      orderCode: "",
      orderData: {},
      goodsData: {},
      checkStatus: false,
      isEmployee: true,
    };
  },
  created() {
    document.documentElement.clientWidth;
    // //缓存id(token获取)和链接(商品返回)
    // sessionStorage.setItem(
    //   "kid",
    //   this.$route.params["id"] || this.$route.query["id"]
    // );
    // sessionStorage.setItem("returnUrl", encodeURIComponent(location.href));
    //清除页面记录
    sessionStorage.removeItem("activeIndex");
    let self = this;
    // //用户访问开始时间
    // if (!utils.getSessionStorage("accessStartTime")) {
    //   sessionStorage.setItem("accessStartTime", new Date().getTime());
    // }
    //如果链接上没带有相关标识或pc版微信浏览器则清除缓存
    if (
      !utils.getQueryString("rootUserId") ||
      !utils.getQueryString("forwardKey") ||
      navigator.userAgent.indexOf("WindowsWechat") != -1
    ) {
      sessionStorage.removeItem("forwardKey");
      sessionStorage.removeItem("parentForwardKey");
      sessionStorage.removeItem("rootUserId");
    }

    utils.wxAuth().then(() => {
      // 配置js-sdk
      utils.setJsSdk().then(() => {});
    });
  },
  mounted() {
    document.getElementsByTagName("title")[0].innerText = "商品核销";
    this.orderCode = this.$route.query.id;
    this.getOrderDetail();
  },
  methods: {
    getOrderDetail() {
      let _this = this;
      api
        .request("getOrderCheckDetail", { orderCode: _this.orderCode })
        .then((result) => {
          if (result.status == 0 && result.data.code == 0) {
            _this.orderData = result.data.data.orderInfo;
            _this.goodsData = result.data.data.goodsInfo;
            _this.checkStatus = result.data.data.orderInfo.status == 2 ? true : false;
          } else if (result.status == 0 && result.data.code == 5) {
            _this.isEmployee = false;
          }
        });
    },
    checkOrder() {
      let _this = this;
      api
        .request("checkOrder", { orderCode: _this.orderCode })
        .then((result) => {
          if (result.status == 0 && result.data.success == 0) {
            _this.checkStatus = true;
          }
        });
    },
  },
};
</script>
<style scoped>
.writeoff {
  height: 100rem;
  font-size: 0.32rem;
  color: #666;
  padding: 0.32rem;
  max-height: 100vh;
  overflow: scroll;
  background-color: #f2f3f5;
}
.writeoff .title {
  color: #333;
}
.writeoff .wrap {
  padding: 0.32rem;
  background-color: #fff;
}
.writeoff .wrap .clo {
  display: flex;
}
.writeoff .wrap .clo > div:first-child {
  width: 1.8rem;
}
.writeoff .wrap .clo > div:last-child {
  max-width: 7rem;
}
.writeoff .info > div {
  margin-top: 0.32rem;
}
.writeoff .info > div > span:last-child {
  margin-left: 0.32rem;
}
.writeoff .goods-info .goods-div {
  display: flex;
  margin-top: 0.3rem;
}
.writeoff .goods-info .goods-div .info-text {
  margin-left: 0.3rem;
}
.writeoff .goods-info .goods-div .price {
  font-size: 0.4rem;
  color: #333;
}
.writeoff .goods-info .total {
  text-align: right;
  padding-right: 0.32rem;
}
.writeoff .btn {
  width: 8.72rem;
  height: 1.2rem;
  line-height: 1.2rem;
  color: #fff;
  background-color: #2e6af8;
  text-align: center;
  font-size: 0.426rem;
  margin: auto;
}
.writeoff .used {
  color: #353535;
  font-size: 0.426rem;
  margin-top: 0.3rem;
}

.writeoff .status {
  font-size: 0.37rem;
  color: #faab0c;
  position: absolute;
  top: 0.3rem;
  right: 0.5rem;
}
</style>